module.exports = __webpack_public_path__ + "img/hr-green-hairy-grass-02.5ab1b177.png";